import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getConnection, Repository } from 'typeorm';
import { ConfCallDTO, PaginationDto } from './dto/conf-call.dto';
import { ConfCollResponseModel, AllConfCollResponseModel } from './dto/conf-call-response-module';
import { ConfCallEntity } from './conf-call.entity';
import { ConfGuestEntity } from './conf-guests.entity';
import { async } from 'rxjs/internal/scheduler/async';
import { empty } from 'rxjs';

@Injectable()
export class ConfCallService {

    constructor(
        @InjectRepository(ConfCallEntity)
        private ccRepo: Repository<ConfCallEntity>,
        @InjectRepository(ConfGuestEntity)
        private cgRepo: Repository<ConfGuestEntity>,
    ) {}


    async createCall(queryParams, ConfCallDTO:ConfCallDTO, request: Request): Promise<ConfCollResponseModel> {
        const response = new ConfCollResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const saved = await this.ccRepo.save(ConfCallDTO);
                if(saved) {
                    if(ConfCallDTO.guestIds) {
                        var dataToPost = ConfCallDTO.guestIds.split(',').map((el) => {
                            return {
                                meetingId:saved.Id,
                                userId: parseInt(el),
                                adminId:ConfCallDTO.adminId
                            };
                        });
                        await this.cgRepo.save(dataToPost);
                    }
                    response.status = true;
                    response.data   = saved;
                    response.statusCode = 50000;
                    response.internalMessage = 'conference call data stored successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'conference call data not saved')
                }
            } else {
                const saved = await this.ccRepo.save(ConfCallDTO);
                if(saved) {
                    if(ConfCallDTO.guestIds) {
                        var dataToPost = ConfCallDTO.guestIds.split(',').map((el) => {
                            return {
                                meetingId:saved.Id,
                                userId: parseInt(el),
                                adminId:ConfCallDTO.adminId
                            };
                        });
                        await this.cgRepo.save(dataToPost);
                    }
                    response.status = true;
                    response.data   = saved;
                    response.statusCode = 50000;
                    response.internalMessage = 'conference call data stored successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'conference call data not saved')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getCalls(pageDto:PaginationDto, userid, request:Request): Promise<AllConfCollResponseModel> {
        const response = new AllConfCollResponseModel();
        try {
            if(pageDto.apiVersion == 1) {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                }
                const cmntData = await this.ccRepo.find({
                    where: {status: true}
                });
                const finData: any[] = [];
                if(cmntData) {                    
                    const promises = cmntData.map(async (c) => {
                        let guests = await this.cgRepo.find({
                            where:[{meetingId:c.Id,userId:userid},
                                {meetingId:c.Id,adminId:userid}]
                        })
                      //  if(c.adminId == userid || !empty(guests)) {
                            return {
                                Id: c.Id,
                                meetingName: c.meetingName,
                                adminToken: c.adminToken,
                                userToken: c.userToken,
                                startTime: c.startTime,
                                endTime:c.endTime,
                                meetingId:c.meetingId,
                                adminId:c.adminId,
                                description:c.description,
                                guests:guests
                            }
                       // }
                        
                        /* finData.push({
                            Id: c.Id,
                            meetingName: c.meetingName,
                            adminToken: c.adminToken,
                            userToken: c.userToken,
                            startTime: c.startTime,
                            endTime:c.endTime,
                            meetingId:c.meetingId
                        }) */
                    })
                    const da = await Promise.all(promises);
                    da.map((c) => { 
                        if(c.adminId == userid || (c.guests).length > 0) {                         
                            finData.push({
                                Id: c.Id,
                                meetingName: c.meetingName,
                                adminToken: c.adminToken,
                                userToken: c.userToken,
                                startTime: c.startTime,
                                endTime:c.endTime,
                                meetingId:c.meetingId,
                                adminId:c.adminId,
                                description:c.description,
                                guests:c.guests
                            })
                        }
                    }); 
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                }
                const cmntData = await this.ccRepo.find({
                    where: {status: true}
                });
                const finData: any[] = [];
                if(cmntData) {                    
                    const promises = cmntData.map(async (c) => {
                        let guests = await this.cgRepo.find({
                            where:{meetingId:c.Id,adminId:c.adminId}
                        })
                        return {
                            Id: c.Id,
                            meetingName: c.meetingName,
                            adminToken: c.adminToken,
                            userToken: c.userToken,
                            startTime: c.startTime,
                            endTime:c.endTime,
                            meetingId:c.meetingId,
                            adminId:c.adminId,
                            description:c.description,
                            guests:guests
                        }
                        /* finData.push({
                            Id: c.Id,
                            meetingName: c.meetingName,
                            adminToken: c.adminToken,
                            userToken: c.userToken,
                            startTime: c.startTime,
                            endTime:c.endTime,
                            meetingId:c.meetingId
                        }) */
                    })
                    const da = await Promise.all(promises);
                    da.map((c) => {                          
                        finData.push({
                            Id: c.Id,
                            meetingName: c.meetingName,
                            adminToken: c.adminToken,
                            userToken: c.userToken,
                            startTime: c.startTime,
                            endTime:c.endTime,
                            meetingId:c.meetingId,
                            adminId:c.adminId,
                            description:c.description,
                            guests:c.guests
                        })
                    }); 
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }    
    
}
